let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cjhdF")).then(() => parcelRequire('225Fx'));